import avatar from "../../../img/avatar.jpg";
import React from "react";
import MoneyFormat from "../../layout/MoneyFormat";
import SingleProductReport from "../../products/SingleProductReport";
import SingleEmployeeReport from "../SingleEmployeeReport";

const EmployeeAbout = ({employee}) => {
    const {id} = employee;
    return (
        <>
            <div className="card mb-3">
                <div className="card-header">
                    <h5 className="card-title mb-0">Xodim ma'umotlari</h5>
                </div>
                <div className="card-body text-center">
                    <div className="row">
                        <div className="col-md-3">
                            <img src={avatar} alt="Christina Mason"
                                 className="img-fluid rounded-circle m-2 mb-2"
                                 width="128" height="128"/>
                            <h5 className="card-title mb-0">{employee?.first_name} {employee?.last_name} </h5>
                            <div className="text-muted mb-2">{employee?.email}</div>
                        </div>
                        <div className="col-md-9">

                            <div className="d-flex align-items-center">
                                <div className="card-title m-2">INN:</div>
                                <div
                                    className="text-muted m-0">{employee?.inn}</div>
                            </div>

                            <div className="d-flex align-items-center">
                                <div className="card-title m-2">Manzili:</div>
                                <div
                                    className="text-muted  m-0">{employee?.address}</div>
                            </div>

                            <div className="d-flex align-items-center">
                                <div className="card-title m-2">Telefon:</div>
                                <div
                                    className="text-muted  m-0">{employee?.phone}</div>
                            </div>

                            <div className="d-flex align-items-center">
                                <div className="card-title m-2">Kasbi:</div>
                                <div
                                    className="text-muted  m-0">{employee?.profession}</div>
                            </div>

                            <div className="d-flex align-items-center">
                                <div className="card-title m-2">Holati:</div>
                                <div
                                    className="text-muted m-0">{employee?.status == 'hired' ? 'Faol' : 'Ishlamayapti'}</div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header">Hisobot chiqarish(<b>Ishlagan va to'lovlar</b>)</div>
                <div className="card-body">
                    <SingleEmployeeReport id={id}/>
                </div>
            </div>
        </>


    )
}

export default EmployeeAbout;